class QuantityInput extends HTMLElement {
    constructor() {
      super();
      
      this.input = this.querySelector('input[type="number"]');
      this.plusButton = this.querySelector('button[name="plus"]');
      this.minusButton = this.querySelector('button[name="minus"]');
      
      // Agregar event listeners
      this.plusButton.addEventListener('click', () => {
        this.cambiarCantidad(1);
      });
      
      this.minusButton.addEventListener('click', () => {
        this.cambiarCantidad(-1);
      });
    }

    cambiarCantidad(delta) {
      let valorActual = parseInt(this.input.value);
      let nuevoValor = valorActual + delta;
      
      
      // Validar límites
      if (nuevoValor >= parseInt(this.input.min)) {
        this.input.value = nuevoValor;
        
        // Disparar evento de cambio
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Actualizar estado de botones
        this.minusButton.disabled = nuevoValor <= parseInt(this.input.min);
      } else {
      }
    }
}

customElements.define('quantity-input', QuantityInput);
  